import './App.scss';
import { Wordle } from './components/Wordle';

function App() {
  return <Wordle />;
}

export default App;
